export default "__VITE_ASSET__B4UOl_Cl__"